import PricesAndPlansTypes from './PricesAndPlansTypes';

export default PricesAndPlansTypes;
